export default [
  { label: " الرجاء تحديد", value: "" },
  { label: "أفغانستان", value: "AFG" },
  { label: "ألبانيا", value: "ALB" },
  { label: "الجزائر", value: "DZA" },
  { label: "ساموا الأمريكية", value: "ASM" },
  { label: "أندورا", value: "AND" },
  { label: "أنغولا", value: "AGO" },
  { label: "أنغيلا", value: "AIA" },
  { label: "أنتاركتيكا", value: "ATA" },
  { label: "أنتيغوا وبربودا", value: "ATG" },
  { label: "الأرجنتين", value: "ARG" },
  { label: "أرمينيا", value: "ARM" },
  { label: "أروبا", value: "ABW" },
  { label: "أستراليا", value: "AUS" },
  { label: "النمسا", value: "AUT" },
  { label: "أذربيجان", value: "AZE" },
  { label: "جزر البهاما", value: "BHS" },
  { label: "مملكة البحرين", value: "BHR" },
  { label: "بنغلاديش", value: "BGD" },
  { label: "بربادوس", value: "BRB" },
  { label: "بيلاروسيا", value: "BLR" },
  { label: "بلجيكا", value: "BEL" },
  { label: "بليز", value: "BLZ" },
  { label: "بنين", value: "BEN" },
  { label: "برمودا", value: "BMU" },
  { label: "بوتان", value: "BTN" },
  { label: "بوليفيا", value: "BOL" },
  { label: "البوسنة والهرسك", value: "BIH" },
  { label: "بوتسوانا", value: "BWA" },
  { label: "جزيرة بوفيت", value: "BVT" },
  { label: "البرازيل", value: "BRA" },
  { label: "إقليم المحيط البريطاني الهندي", value: "IOT" },
  { label: "بروناي دار السلام", value: "BRN" },
  { label: "بلغاريا", value: "BGR" },
  { label: "بوركينا فاسو", value: "BFA" },
  { label: "بوروندي", value: "BDI" },
  { label: "كمبوديا", value: "KHM" },
  { label: "الكاميرون", value: "CMR" },
  { label: "كندا", value: "CAN" },
  { label: "كيب فيردي", value: "CPV" },
  { label: "جزر كايمان", value: "CYM" },
  { label: "جمهورية افريقيا الوسطى", value: "CAF" },
  { label: "تشاد", value: "TCD" },
  { label: "تشيلي", value: "CHL" },
  { label: "الصين", value: "CHN" },
  { label: "جزيرة عيد الميلاد", value: "CXR" },
  { label: "جزر كوكوس (كيلينغ)", value: "CCK" },
  { label: "كولومبيا", value: "COL" },
  { label: "القادمين", value: "COM" },
  { label: "الكونغو - جمهورية", value: "COG" },
  { label: "الكونغو - جمهورية الديمقراطية (زائير سابقًا)", value: "COD" },
  { label: "جزر كوك", value: "COK" },
  { label: "كوستا ريكا", value: "CRI" },
  { label: "Côte Divoire (ساحل العاج)", value: "CIV" },
  { label: "كرواتيا (Hrvatska)", value: "HRV" },
  { label: "كوبا", value: "CUB" },
  { label: "قبرص", value: "CYP" },
  { label: "الجمهورية التشيكية", value: "CZE" },
  { label: "الدنمارك", value: "DNK" },
  { label: "جيبوتي", value: "DJI" },
  { label: "دومينيكا", value: "DMA" },
  { label: "جمهورية الدومنيكان", value: "DOM" },
  { label: "الإكوادور", value: "ECU" },
  { label: "مصر", value: "EGY" },
  { label: "السلفادور", value: "SLV" },
  { label: "غينيا الإستوائية", value: "GNQ" },
  { label: "إريتريا", value: "ERI" },
  { label: "إستونيا", value: "EST" },
  { label: "أثيوبيا", value: "ETH" },
  { label: "جزر فورو", value: "FRO" },
  { label: "جزر فوكلاند (مالفيناس)", value: "FLK" },
  { label: "فيجي", value: "FJI" },
  { label: "فنلندا", value: "FIN" },
  { label: "فرنسا", value: "FRA" },
  { label: "غيانا الفرنسية", value: "GUF" },
  { label: "بولينيزيا الفرنسية", value: "PYF" },
  { label: "المناطق الجنوبية لفرنسا", value: "ATF" },
  { label: "غابون", value: "GAB" },
  { label: "غامبيا", value: "GMB" },
  { label: "جورجيا", value: "GEO" },
  { label: "ألمانيا (دويتشلاند)", value: "DEU" },
  { label: "غانا", value: "GHA" },
  { label: "جبل طارق", value: "GIB" },
  { label: "اليونان", value: "GRC" },
  { label: "الأرض الخضراء", value: "GRL" },
  { label: "غرينادا", value: "GRD" },
  { label: "غواديلوب", value: "GLP" },
  { label: "غوام", value: "GUM" },
  { label: "غواتيمالا", value: "GTM" },
  { label: "غيرنسي", value: "GBG " },
  { label: "غينيا", value: "GIN" },
  { label: "غينيا بيساو", value: "GNB" },
  { label: "غيانا", value: "GUY" },
  { label: "هايتي", value: "HTI" },
  { label: "قلب الجزيرة وجزر ماكدونالز", value: "HMD" },
  { label: "هندوراس", value: "HND" },
  { label: "هونغ كونغ (المنطقة الإدارية الخاصة في الصين)", value: "HKG" },
  { label: "هنغاريا", value: "HUN" },
  { label: "أيسلندا", value: "ISL" },
  { label: "الهند", value: "IND" },
  { label: "إندونيسيا", value: "IDN" },
  { label: "إيران (جمهورية إيران الإسلامية)", value: "IRN" },
  { label: "العراق", value: "IRQ" },
  { label: "أيرلندا", value: "IRL" },
  { label: "إسرائيل", value: "ISR" },
  { label: "إيطاليا", value: "ITA" },
  { label: "جامايكا", value: "JAM" },
  { label: "اليابان", value: "JPN" },
  { label: "جيرسي", value: "GBJ " },
  { label: "الأردن (مملكة الهاشميت الأردنية)", value: "JOR" },
  { label: "كازاخستان", value: "KAZ" },
  { label: "كينيا", value: "KEN" },
  { label: "كيريباتي", value: "KIR" },
  { label: "كوريا (جمهورية كوريا الشمالية الديمقراطية (شمال] كوريا)", value: "PRK" },
  { label: "كوريا (جمهورية [جنوب] كوريا)", value: "KOR" },
  { label: "الكويت", value: "KWT" },
  { label: "جمهورية قبرص شمال التركية", value: "KKTC" },
  { label: "قيرغيزستان", value: "KGZ" },
  { label: "جمهورية لاو الشعبية الديمقراطية", value: "LAO" },
  { label: "لاتفيا", value: "LVA" },
  { label: "لبنان", value: "LBN" },
  { label: "ليسوتو", value: "LSO" },
  { label: "ليبيريا", value: "LBR" },
  { label: "ليبيا (العربية العربية الجماهيرية)", value: "LBY" },
  { label: "ليختنشتاين (فورستنتوم ليختنشتاين)", value: "LIE" },
  { label: "ليتوانيا", value: "LTU" },
  { label: "لوكسمبورغ", value: "LUX" },
  { label: "ماكاو (المنطقة الإدارية الخاصة في الصين)", value: "MAC" },
  { label: "مقدونيا (جمهورية مقدونيا السابقة يوغسلاف)", value: "MKD" },
  { label: "مدغشقر", value: "MDG" },
  { label: "ملاوي", value: "MWI" },
  { label: "ماليزيا", value: "MYS" },
  { label: "جزر المالديف", value: "MDV" },
  { label: "مالي", value: "MLI" },
  { label: "مالطا", value: "MLT" },
  { label: "جزر مارشال", value: "MHL" },
  { label: "مارتينيك", value: "MTQ" },
  { label: "موريتانيا", value: "MRT" },
  { label: "موريشيوس", value: "MUS" },
  { label: "مايوت", value: "MYT" },
  { label: "المكسيك", value: "MEX" },
  { label: "ميكرونيزيا (ولايات ميكرونيزيا الموحدة)", value: "FSM" },
  { label: "مولدوفا", value: "MDA" },
  { label: "موناكو", value: "MCO" },
  { label: "منغوليا", value: "MNG" },
  { label: "مونتسيرات", value: "MSR" },
  { label: "المغرب", value: "MAR" },
  { label: "موزمبيق (موهامبيك)", value: "MOZ" },
  { label: "ميانمار (بورما سابقا)", value: "MMR" },
  { label: "ناميبيا", value: "NAM" },
  { label: "ناورو", value: "NRU" },
  { label: "نيبال", value: "NPL" },
  { label: "هولندا", value: "NLD" },
  { label: "جزر الأنتيل الهولندية", value: "ANT" },
  { label: "كاليدونيا الجديدة", value: "NCL" },
  { label: "نيوزيلاندا", value: "NZL" },
  { label: "نيكاراغوا", value: "NIC" },
  { label: "النيجر", value: "NER" },
  { label: "نيجيريا", value: "NGA" },
  { label: "نيو", value: "NIU" },
  { label: "جزيرة نورفولك", value: "NFK" },
  { label: "جزر مريانا الشمالية", value: "MNP" },
  { label: "النرويج", value: "NOR" },
  { label: "سلطنة عمان", value: "OMN" },
  { label: "باكستان", value: "PAK" },
  { label: "بالاو", value: "PLW" },
  { label: "فلسطين", value: "PS" },
  { label: "الاراضي الفلسطينية", value: "PSE" },
  { label: "بنما", value: "PAN" },
  { label: "بابوا غينيا الجديدة", value: "PNG" },
  { label: "باراجواي", value: "PRY" },
  { label: "بيرو", value: "PER" },
  { label: "فيلبيني", value: "PHL" },
  { label: "بيتكيرن", value: "PCN" },
  { label: "بولندا", value: "POL" },
  { label: "البرتغال", value: "PRT" },
  { label: "بورتوريكو", value: "PRI" },
  { label: "دولة قطر", value: "QAT" },
  { label: "جمع شمل", value: "REU" },
  { label: "جمهورية كوسوفو", value: "KSV" },
  { label: "رومانيا", value: "ROU" },
  { label: "الاتحاد الروسي", value: "RUS" },
  { label: "رواندا", value: "RWA" },
  { label: "القديس هيلينا", value: "SHN" },
  { label: "سانت كيتس ونيفيس", value: "KNA" },
  { label: "القديسة لوسيا", value: "LCA" },
  { label: "سانت بيير وميكلون", value: "SPM" },
  { label: "سانت فنسنت وجزر غرينادين", value: "VCT" },
  { label: "ساموا (ساموا الغربية سابقًا)", value: "WSM" },
  { label: "سان مارينو (جمهورية)", value: "SMR" },
  { label: "ساو تومي وبينسبيب", value: "STP" },
  { label: "المملكة العربية السعودية (مملكة المملكة العربية السعودية)", value: "SAU" },
  { label: "السنغال", value: "SEN" },
  { label: "صربيا والجبل الأسود", value: "SCG" },
  { label: "سيشيل", value: "SYC" },
  { label: "سيرا ليون", value: "SLE" },
  { label: "سنغافورة", value: "SGP" },
  { label: "سلوفاكيا (جمهورية سلوفاك)", value: "SVK" },
  { label: "سلوفينيا", value: "SVN" },
  { label: "جزر سليمان", value: "SLB" },
  { label: "الصومال", value: "SOM" },
  { label: "جنوب إفريقيا (Zuid Afrika)", value: "ZAF" },
  { label: "جورجيا الجنوبية وجزر ساندويتش الجنوبية", value: "SGS" },
  { label: "إسبانيا (españa)", value: "ESP" },
  { label: "سيريلانكا", value: "LKA" },
  { label: "السودان", value: "SDN" },
  { label: "Surilabel", value: "SUR" },
  { label: "سفالبارد وجان ماين", value: "SJM" },
  { label: "سوازيلاند", value: "SWZ" },
  { label: "السويد", value: "SWE" },
  { label: "سويسرا (اتحاد هيلفيتيا)", value: "CHE" },
  { label: "الجمهورية العربية السورية", value: "SYR" },
  { label: "تايوان (تايبيه الصينية ل IOC)", value: "TWN" },
  { label: "طاجيكستان", value: "TJK" },
  { label: "تنزانيا", value: "TZA" },
  { label: "تايلاند", value: "THA" },
  { label: "تيمور-ليست (تيمور الشرقية سابقا)", value: "TLS" },
  { label: "توجو", value: "TGO" },
  { label: "توكيلاو", value: "TKL" },
  { label: "تونغا", value: "TON" },
  { label: "ترينداد وتوباغو", value: "TTO" },
  { label: "تونس", value: "TUN" },
  { label: "تركمانستان", value: "TKM" },
  { label: "جزر تركس وكايكوس", value: "TCA" },
  { label: "توفالو", value: "TUV" },
  { label: "ديك رومى", value: "TUR" },
  { label: "أوغندا", value: "UGA" },
  { label: "أوكرانيا", value: "UKR" },
  { label: "الإمارات العربية المتحدة", value: "ARE" },
  { label: "المملكة المتحدة (بريطانيا العظمى)", value: "GBR" },
  { label: "الولايات المتحدة الأمريكية", value: "USA" },
  { label: "جزر الولايات المتحدة البعيدة الصغرى", value: "UMI" },
  { label: "أوروغواي", value: "URY" },
  { label: "أوزبكستان", value: "UZB" },
  { label: "فانواتو", value: "VUT" },
  { label: "مدينة الفاتيكان (الكرسي الرسولي)", value: "VAT" },
  { label: "فنزويلا", value: "VEN" },
  { label: "فييت نام", value: "VNM" },
  { label: "جزر العذراء البريطانية)", value: "VGB" },
  { label: "جزر فيرجن (الولايات المتحدة)", value: "VIR" },
  { label: "واليس وفوتونا", value: "WLF" },
  { label: "الصحراء الغربية (الصحراء الإسبانية السابقة)", value: "ESH" },
  { label: "اليمن", value: "YEM" },
  { label: "زامبيا", value: "ZMB" },
  { label: "زيمبابوي", value: "ZIM " }
];
